import { QueryClient } from '@tanstack/react-query';

/**
 * Client global do TanStack Query.
 * - Não refetch on focus por padrão (UX mais calmo para tabelas densas).
 * - Retry 1× (evita marretar API em caso de bug temporário).
 * - 1 minuto de stale time — suficiente para o gestor abrir várias telas
 *   sem refetch, e fresco o bastante para não exibir dado velho.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
